<app-nav-header></app-nav-header>
<div class="wrapper">
    <div id="corporatePhilosophyPage">
        <div class="main">
            <!-- Banner -->
            <div class="bannerArea">
                <div class="bannerBox">
                    <div class="wordBox">
                        <h1>
                            {{
                                'aboutKunYou.corporatePhilosophy.title'
                                    | translate
                            }}
                        </h1>
                    </div>
                </div>
            </div>
            <!-- 內文 -->
            <div class="corporatePhilosophyArea">
                <div class="corporatePhilosophyBox">
                    <div class="wordBox">
                        <img
                            class="floating-img"
                            src="../../../../assets/images/corporatePhilosophyPage/hero.jpg" />

                        <h2>
                            {{
                                'aboutKunYou.corporatePhilosophy.vision.title'
                                    | translate
                            }}
                        </h2>
                        <p>
                            {{
                                'aboutKunYou.corporatePhilosophy.vision.content'
                                    | translate
                            }}
                        </p>
                        <h2>
                            {{
                                'aboutKunYou.corporatePhilosophy.mission.title'
                                    | translate
                            }}
                        </h2>
                        <p>
                            {{
                                'aboutKunYou.corporatePhilosophy.mission.content'
                                    | translate
                            }}
                        </p>
                        <h2>
                            {{
                                'aboutKunYou.corporatePhilosophy.team.title'
                                    | translate
                            }}
                        </h2>
                        <p>
                            {{
                                'aboutKunYou.corporatePhilosophy.team.content'
                                    | translate
                            }}
                        </p>
                        <h2>
                            {{
                                'aboutKunYou.corporatePhilosophy.customerFocus.title'
                                    | translate
                            }}
                        </h2>
                        <p>
                            {{
                                'aboutKunYou.corporatePhilosophy.customerFocus.content'
                                    | translate
                            }}
                        </p>
                        <h2>
                            {{
                                'aboutKunYou.corporatePhilosophy.sustainability.title'
                                    | translate
                            }}
                        </h2>
                        <p>
                            {{
                                'aboutKunYou.corporatePhilosophy.sustainability.content'
                                    | translate
                            }}
                        </p>
                        <h2>
                            {{
                                'aboutKunYou.corporatePhilosophy.excellence.title'
                                    | translate
                            }}
                        </h2>
                        <p>
                            {{
                                'aboutKunYou.corporatePhilosophy.excellence.content'
                                    | translate
                            }}
                        </p>
                        <h2>
                            {{
                                'aboutKunYou.corporatePhilosophy.future.title'
                                    | translate
                            }}
                        </h2>
                        <p>
                            {{
                                'aboutKunYou.corporatePhilosophy.future.content'
                                    | translate
                            }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>
